// @flow
import * as React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageHeading from '../Common/PageHeading';
import Typography from '../Common/Typography';
import TextBox from '../Common/TextBox';
import { Button } from '../Common/Button';
import ErrorAlert from '../Common/ErrorAlert';
import atLeast from '../../styling/atLeast';

const Body = styled.div`
  padding: 1rem;
`;

const StyledTextBox = styled(TextBox)`
  width: 100%;

  ${atLeast.small`
    max-width: 350px;
  `}
`;

const ButtonContainer = styled.div`
  margin-top: 1rem;

  button:first-child {
    margin-right: 0.5rem;
  }
`;

type Props = {
  emailAddress: string,
  errors: Array<string>,
  onChange: (SyntheticKeyboardEvent<HTMLInputElement>) => mixed,
  onCancel: () => void,
  onSubmit: (SyntheticEvent<HTMLButtonElement>) => mixed
};

const ForgottenPasswordPageDisplay = React.memo<Props>((props: Props) => (
  <>
    <PageHeading>
      <Typography kind="h3">Forgotten Password</Typography>
      <FontAwesomeIcon icon="key" size="lg" />
    </PageHeading>
    <Body>
      <ErrorAlert errors={props.errors} />
      <p>
        Please enter the email address of the account you wish to recover, you
        will receive a new password in the next few minutes.
      </p>
      <form onSubmit={props.onSubmit}>
        <StyledTextBox
          type="email"
          autoFocus
          placeholder="Enter email address"
          value={props.emailAddress}
          onChange={props.onChange}
        />
        <ButtonContainer>
          <Button kind="secondary" type="button" onClick={props.onCancel}>
            Cancel
          </Button>
          <Button kind="primary" type="submit">
            Submit
          </Button>
        </ButtonContainer>
      </form>
    </Body>
  </>
));

export default ForgottenPasswordPageDisplay;
